import { render, staticRenderFns } from "./focus-words-manager-form.vue?vue&type=template&id=722df7d0&scoped=true"
import script from "./focus-words-manager-form.ts?vue&type=script&lang=ts&external"
export * from "./focus-words-manager-form.ts?vue&type=script&lang=ts&external"
import style0 from "./focus-words-manager-form.less?vue&type=style&index=0&id=722df7d0&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722df7d0",
  null
  
)

export default component.exports